import types from "rdx/modules/seatApprovals/types";
import createAction from "rdx/utils/createAction";

export default {
  getSeatApprovals: (payload) => createAction(types.GET_SEATS_APPROVALS, payload),
  setSeatApprovals: (payload) => createAction(types.SET_SEATS_APPROVALS, payload),
  approveSeatApproval: (payload) => createAction(types.APPROVE_SEATS_APPROVAL, payload),
  declineSeatApproval: (payload) => createAction(types.DECLINE_SEATS_APPROVAL, payload),
};
